import { useEffect, useState } from "react";
import RealTimeService from "../../../../../realtime/RealTimeService";

export const useAlertDimissed = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const subscription = RealTimeService.subscribe(
      "*",
      "ALERT-DIMISSED",
      (message) => {
        // console.log("ALERT-DIMISSED", message.notificationData);
        setData(message.notificationData);
      }
    );
    return subscription.unsubscribe;
  }, []);

  return data;
};
